 function populateDropdown(id,firstOption,optionsArray) {
     var dropdown = $('#'+id);
     
     dropdown.empty();  
 
     dropdown.append($('<option></option>').val('').text(firstOption));
 
     $.each(optionsArray, function(index, item) {
      
       var option = $('<option></option>'); 
       option.val(item.value);
       option.text(item.text);
 
       dropdown.append(option);
     });
   }


 
   $('select.homeformDropdown').not('#formDropdownResourceType').on('change', function (e) {
         e.preventDefault();
         var dropdownId = $(this).attr('id');
       
         
         var data = {
             TopicName: $('#formDropdownTopic').val(),
             RoleName: $('#formDropdownRole').val(),
             ResourceType: $('#formDropdownResourceType').val(),
         }
         $.ajax({
             url: "/umbraco/surface/Search/ResourceFiltering",
             type: "GET",
             data: data,
             dataType: "json",
             success: function (response) {
                
                 if(dropdownId=='formDropdownTopic'){
                     populateDropdown('formDropdownRole','Select Role',response.roles);  
                     populateDropdown('formDropdownResourceType','Select Resource Type',response.resourceTypes);
                 } else if(dropdownId=='formDropdownRole'){  
                     populateDropdown('formDropdownResourceType','Select Resource Type',response.resourceTypes);
                 } 
                
             }
         });
     });
 